/* =========================================================================
   The Festive Atelier — theme.js (vanilla, no dependencies)
   → assets/theme.js in Shopify. Every module is guarded so it only runs
     when its markup exists on the page (works per-section).
   ========================================================================= */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var store = {
    get: function (k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  };

  /* ---------- Sticky header shadow */
  var header = $('.site-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* ---------- Fairy-light bulbs under header */
  $$('[data-light-string]').forEach(function (el) {
    var n = Math.max(18, Math.round(window.innerWidth / 46));
    var wrap = document.createElement('div'); wrap.className = 'light-string__bulbs';
    for (var i = 0; i < n; i++) {
      var b = document.createElement('span'); b.className = 'bulb';
      b.style.setProperty('--d', (Math.random() * 2.4).toFixed(2) + 's');
      b.style.marginTop = (3 + Math.sin(i / n * Math.PI * 6) * 2.5).toFixed(1) + 'px';
      wrap.appendChild(b);
    }
    el.appendChild(wrap);
  });

  /* ---------- Announcement bar rotation (mobile shows one at a time) */
  $$('[data-announcement]').forEach(function (bar) {
    var items = $$('.announcement__item', bar); if (!items.length) return;
    var i = 0;
    var show = function (n) { i = (n + items.length) % items.length; items.forEach(function (it, k) { it.classList.toggle('is-active', k === i); }); };
    show(0);
    var prev = $('[data-prev]', bar), next = $('[data-next]', bar);
    prev && prev.addEventListener('click', function () { show(i - 1); });
    next && next.addEventListener('click', function () { show(i + 1); });
    if (!reduceMotion) setInterval(function () { show(i + 1); }, 4500);
  });

  /* ---------- Mobile drawer */
  var drawer = $('[data-drawer]');
  if (drawer) {
    var open = function () { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; };
    var close = function () { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; };
    $$('[data-drawer-open]').forEach(function (b) { b.addEventListener('click', open); });
    $$('[data-drawer-close]', drawer).forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- Sparkles (hero + any [data-sparkles]) */
  $$('[data-sparkles]').forEach(function (layer) {
    var count = parseInt(layer.getAttribute('data-sparkles'), 10) || 24;
    for (var i = 0; i < count; i++) {
      var s = document.createElement('span');
      var star = Math.random() < .35;
      s.className = 'sparkle' + (star ? ' sparkle--star' : '');
      s.style.left = (Math.random() * 100).toFixed(2) + '%';
      s.style.top = (Math.random() * 100).toFixed(2) + '%';
      s.style.setProperty('--s', (star ? 8 + Math.random() * 8 : 3 + Math.random() * 6).toFixed(1) + 'px');
      s.style.setProperty('--t', (2 + Math.random() * 3).toFixed(2) + 's');
      s.style.setProperty('--d', (Math.random() * 4).toFixed(2) + 's');
      layer.appendChild(s);
    }
  });

  /* ---------- Gold sparkle trail on hero (pointer: fine only) */
  var trailHost = $('[data-sparkle-trail]');
  if (trailHost && !reduceMotion && window.matchMedia('(pointer: fine)').matches) {
    var last = 0;
    trailHost.addEventListener('mousemove', function (e) {
      var now = performance.now(); if (now - last < 40) return; last = now;
      var p = document.createElement('span');
      p.className = 'burst';
      p.style.left = e.clientX + 'px'; p.style.top = e.clientY + 'px';
      p.style.width = p.style.height = (3 + Math.random() * 4) + 'px';
      p.style.setProperty('--bx', (Math.random() * 30 - 15) + 'px');
      p.style.setProperty('--by', (10 + Math.random() * 30) + 'px');
      p.style.setProperty('--bc', Math.random() < .5 ? '#ffe7a3' : '#ffffff');
      document.body.appendChild(p);
      setTimeout(function () { p.remove(); }, 900);
    });
  }

  /* ---------- Snowfall (canvas) + toggle */
  var canvas = $('.snow-canvas'), toggle = $('.snow-toggle');
  if (canvas && !reduceMotion) {
    var ctx = canvas.getContext('2d'), flakes = [], W, H, raf, on = store.get('fa-snow') !== 'off';
    var resize = function () {
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      W = window.innerWidth; H = window.innerHeight;
      canvas.width = W * dpr; canvas.height = H * dpr; canvas.style.width = W + 'px'; canvas.style.height = H + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var target = Math.round(Math.min(110, W / 14));
      while (flakes.length < target) flakes.push(make(true));
      flakes.length = target;
    };
    var make = function (anywhere) {
      return { x: Math.random() * W, y: anywhere ? Math.random() * H : -10, r: .8 + Math.random() * 2.6, s: .3 + Math.random() * .9, w: Math.random() * Math.PI * 2, o: .35 + Math.random() * .55 };
    };
    var tick = function () {
      ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < flakes.length; i++) {
        var f = flakes[i];
        f.y += f.s; f.w += .012; f.x += Math.sin(f.w) * .4;
        if (f.y > H + 10) flakes[i] = f = make(false);
        ctx.beginPath(); ctx.arc(f.x, f.y, f.r, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(255,255,255,' + f.o + ')';
        ctx.shadowColor = 'rgba(255,255,255,.8)'; ctx.shadowBlur = f.r * 2;
        ctx.fill();
      }
      raf = requestAnimationFrame(tick);
    };
    var set = function (v) {
      on = v; store.set('fa-snow', v ? 'on' : 'off');
      toggle && toggle.setAttribute('aria-pressed', v ? 'true' : 'false');
      canvas.style.display = v ? '' : 'none';
      cancelAnimationFrame(raf); if (v) tick(); else ctx.clearRect(0, 0, W, H);
    };
    window.addEventListener('resize', resize); resize(); set(on);
    toggle && toggle.addEventListener('click', function () { set(!on); });
    document.addEventListener('visibilitychange', function () { if (document.hidden) cancelAnimationFrame(raf); else if (on) { cancelAnimationFrame(raf); tick(); } });
  } else if (toggle) { toggle.hidden = true; }

  /* ---------- Scroll reveal */
  var revealEls = $$('[data-reveal]');
  if ('IntersectionObserver' in window && !reduceMotion) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
  } else revealEls.forEach(function (el) { el.classList.add('is-in'); });


  var T = window.theme || { routes: {}, strings: {} };

  /* ---------- Sparkle burst */
  var burst = function (x, y) {
    if (reduceMotion) return;
    var colors = ['#f0c96b', '#ff5a5f', '#ffffff', '#63d39a', '#ffe7a3'];
    for (var i = 0; i < 18; i++) {
      var p = document.createElement('span'); p.className = 'burst';
      var a = Math.PI * 2 * i / 18, d = 40 + Math.random() * 50;
      p.style.left = x + 'px'; p.style.top = y + 'px';
      p.style.setProperty('--bx', Math.cos(a) * d + 'px'); p.style.setProperty('--by', Math.sin(a) * d + 'px');
      p.style.setProperty('--bc', colors[i % colors.length]);
      document.body.appendChild(p); setTimeout(function (n) { n.remove(); }.bind(null, p), 950);
    }
  };
  var toast = $('[data-toast]');
  var showToast = function (text, ok) {
    if (!toast) return;
    $('[data-toast-text]', toast).textContent = text;
    toast.classList.toggle('is-error', !ok);
    toast.classList.add('is-show'); clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('is-show'); }, 3600);
  };
  var setCount = function (n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n; el.hidden = n === 0;
      el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
    });
  };

  /* ---------- Add to cart (Shopify AJAX Cart API, falls back to normal form post) */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]'); if (!form || !window.fetch) return;
    e.preventDefault();
    var btn = e.submitter && e.submitter.hasAttribute('data-add-to-cart') ? e.submitter : $('[data-add-to-cart]', form);
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    fetch(T.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return fetch(T.routes.cart + '.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        setCount(cart.item_count);
        if (btn) { var r = btn.getBoundingClientRect(); burst(r.left + r.width / 2, r.top + r.height / 2); }
        showToast((btn && btn.getAttribute('data-product') || '') + ' ' + T.strings.added, true);
      })
      .catch(function (err) { showToast((err && err.description) || T.strings.error, false); })
      .finally(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } });
  });

  /* ---------- UGC carousel arrow */
  $$('[data-carousel]').forEach(function (c) {
    var track = $('[data-carousel-track]', c), next = $('[data-carousel-next]', c);
    var step = function () { var it = track.firstElementChild; return it ? it.getBoundingClientRect().width + 16 : 200; };
    next && next.addEventListener('click', function () {
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      track.scrollTo({ left: atEnd ? 0 : track.scrollLeft + step() * 2, behavior: 'smooth' });
    });
  });

  /* ---------- Country / language selectors submit on change */
  $$('[data-localization] select').forEach(function (s) { s.addEventListener('change', function () { s.form.submit(); }); });

  /* ---------- Cookie preferences link (Shopify native privacy banner) */
  $$('[data-cookie-prefs]').forEach(function (a) {
    var show = function () { if (window.privacyBanner && window.privacyBanner.showPreferences) { a.hidden = false; return true; } };
    if (!show()) setTimeout(show, 2500);
    a.addEventListener('click', function (e) { e.preventDefault(); window.privacyBanner && window.privacyBanner.showPreferences(); });
  });

  /* =====================  COLLECTION PAGE  ===================== */
  var filterPanel = $('[data-filter-panel]');
  if (filterPanel) {
    $$('[data-filter-open]').forEach(function (b) { b.addEventListener('click', function () { filterPanel.classList.add('is-open'); document.body.style.overflow = 'hidden'; }); });
    $$('[data-filter-close]').forEach(function (b) { b.addEventListener('click', function () { filterPanel.classList.remove('is-open'); document.body.style.overflow = ''; }); });
  }
  $$('[data-grid-switch]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var grid = $('[data-collection-grid]'); if (!grid) return;
      $$('[data-grid-switch]').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      grid.setAttribute('data-cols', btn.getAttribute('data-grid-switch'));
      store.set('fa-cols', btn.getAttribute('data-grid-switch'));
    });
    if (store.get('fa-cols') === btn.getAttribute('data-grid-switch')) btn.click();
  });
  /* Storefront filtering: submit the GET form (Shopify builds filter URLs) */
  var filterForm = $('[data-filter-form]');
  if (filterForm) {
    var timer;
    var submit = function () {
      var params = new URLSearchParams(new FormData(filterForm));
      Array.from(params.keys()).forEach(function (k) { if (params.get(k) === '') params.delete(k); });
      window.location.search = params.toString();
    };
    filterForm.addEventListener('change', function (e) { clearTimeout(timer); timer = setTimeout(submit, e.target.type === 'number' ? 600 : 0); });
    var sort = $('[data-sort]'), sortHidden = $('[data-sort-hidden]', filterForm);
    sort && sort.addEventListener('change', function () { sortHidden.value = sort.value; submit(); });
  }

  /* =====================  PRODUCT PAGE  ===================== */
  var gallery = $('[data-gallery]');
  var goToMedia;
  if (gallery) {
    var main = $('[data-gallery-main]', gallery);
    var thumbs = $$('[data-gallery-thumb]', gallery);
    var go = function (t) {
      if (!t || !main) return;
      thumbs.forEach(function (x) { x.setAttribute('aria-current', x === t ? 'true' : 'false'); });
      main.classList.add('is-swapping');
      setTimeout(function () { main.removeAttribute('srcset'); main.src = t.getAttribute('data-src'); main.alt = t.getAttribute('data-alt') || main.alt; main.classList.remove('is-swapping'); }, 180);
    };
    goToMedia = function (id) { go(thumbs.filter(function (t) { return t.getAttribute('data-media-id') === String(id); })[0]); };
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(t); }); });
    var navBtn = function (dir) {
      var cur = thumbs.findIndex(function (x) { return x.getAttribute('aria-current') === 'true'; });
      go(thumbs[(cur + dir + thumbs.length) % thumbs.length]);
    };
    $$('[data-gallery-prev]', gallery).forEach(function (b) { b.addEventListener('click', function () { navBtn(-1); }); });
    $$('[data-gallery-next]', gallery).forEach(function (b) { b.addEventListener('click', function () { navBtn(1); }); });
    var zoomBox = $('[data-zoom]', gallery);
    if (zoomBox && main && window.matchMedia('(pointer: fine)').matches) {
      zoomBox.addEventListener('mousemove', function (e) {
        var r = zoomBox.getBoundingClientRect();
        main.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        main.style.transform = 'scale(1.7)';
      });
      zoomBox.addEventListener('mouseleave', function () { main.style.transform = ''; });
    }
  }

  /* Variant picker: match selected options → variant, update id/price/stock/URL */
  $$('[data-product-section]').forEach(function (sec) {
    var json = $('[data-product-json]', sec), form = $('[data-product-form]', sec); if (!json || !form) return;
    var variants = JSON.parse(json.textContent).variants;
    var groups = $$('[data-option-index]', sec);
    if (!groups.length) return;
    var update = function () {
      var chosen = groups.map(function (g) { var c = $('input:checked', g); return c ? c.value : null; });
      groups.forEach(function (g, i) { var l = $('[data-option-value]', g); if (l) l.textContent = chosen[i]; });
      var v = variants.filter(function (x) { return x.options.every(function (o, i) { return o === chosen[i]; }); })[0];
      var atcs = $$('[data-add-to-cart]', sec), label = $('[data-atc-label]', sec);
      var price = $('[data-price]', sec), save = $('[data-save]', sec), stock = $('[data-stock]', sec), unit = $('[data-unit-price]', sec);
      if (!v) { atcs.forEach(function (b) { b.disabled = true; }); if (label) label.textContent = T.strings.unavailable; return; }
      $('[data-variant-id]', form).value = v.id;
      atcs.forEach(function (b) { b.disabled = !v.available; });
      if (label) label.textContent = v.available ? T.strings.addToCart : T.strings.soldOut;
      if (price) {
        price.classList.toggle('price--sale', !!v.compare);
        price.innerHTML = '<span class="price__current">' + v.price + '</span>' + (v.compare ? '<s class="price__compare">' + v.compare + '</s>' : '');
      }
      if (save) { save.hidden = !v.save; save.textContent = v.save || ''; }
      if (unit) { unit.hidden = !v.unit; unit.textContent = v.unit || ''; }
      if (stock) stock.hidden = !v.available;
      var sp = $('[data-sticky-price]', sec); if (sp) sp.textContent = v.price;
      if (v.media && goToMedia) goToMedia(v.media);
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    };
    groups.forEach(function (g) { $$('input', g).forEach(function (i) { i.addEventListener('change', update); }); });
  });

  /* Quantity stepper (product + cart) */
  $$('[data-qty]').forEach(function (q) {
    var input = $('input', q), min = parseInt(input.min, 10) || 0;
    $$('button', q).forEach(function (b) {
      b.addEventListener('click', function () {
        var v = (parseInt(input.value, 10) || 0) + (b.hasAttribute('data-qty-plus') ? 1 : -1);
        input.value = Math.max(min, Math.min(99, v));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });
  /* Cart page: quantity change updates the cart */
  $$('[data-cart-qty]').forEach(function (i) {
    var t; i.addEventListener('change', function () { clearTimeout(t); t = setTimeout(function () { i.form.submit(); }, 500); });
  });

  /* Sticky add-to-cart bar */
  var sticky = $('[data-sticky-atc]'), atcMain = $('[data-atc-main]');
  if (sticky && atcMain && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) {
      var show = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
      sticky.classList.toggle('is-show', show); document.body.classList.toggle('has-sticky-atc', show);
    }).observe(atcMain);
  }

  /* Countdown to Christmas shipping cut-off (hidden once passed) */
  $$('[data-countdown]').forEach(function (el) {
    var target = new Date(el.getAttribute('data-countdown')).getTime();
    if (!(target > Date.now())) return;
    el.hidden = false;
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var upd = function () {
      var d = Math.max(0, target - Date.now());
      if (!d) { el.hidden = true; return; }
      el.querySelector('[data-d]').textContent = Math.floor(d / 864e5); el.querySelector('[data-h]').textContent = pad(Math.floor(d / 36e5) % 24);
      el.querySelector('[data-m]').textContent = pad(Math.floor(d / 6e4) % 60); el.querySelector('[data-s]').textContent = pad(Math.floor(d / 1e3) % 60);
    };
    upd(); setInterval(upd, 1000);
  });

  /* Product recommendations (Shopify Section Rendering API) */
  $$('[data-recommendations]').forEach(function (el) {
    if (!window.fetch) return;
    fetch(el.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var fresh = $('[data-recommendations]', tmp);
      if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; $$('[data-reveal]', el).forEach(function (n) { n.classList.add('is-in'); }); }
    });
  });
})();
